import React from "react";
import divider from '../../assets/divider.png';
import "./index.scss";

const Title = ({ title, title_en, type }) => {
  return (
    <div className={`divider`}>
      <img style={{ width: '100%' }} src={divider} alt="" />
    </div>
  );
};

export default Title;